export default {
  color: "#E05105",
  background: "#F9F9F7",
  base_url: 'https://structurea.be/',
  blue_structurea: "#05386B",
  white_color: "#fff",
  blue_ligth: "#2B74A7"
};
